import { HttpContextToken } from '@angular/common/http'

export const HTTP_RETRY_ATTEMPT = new HttpContextToken<number>(() => 0)
export const SKIP_PERFORMANCE_METRICS = new HttpContextToken<boolean>(() => false)
